<footer class="footer">
	<div class="languages">
		<div class="languages__list">
			<div *ngFor="let language of languages" class="languages__item" (click)="setLanguage(language)" [ngClass]="{'languages__item--active': isActiveLanguage(language)}">{{ language }}</div>
		</div>
	</div>
	<div class="navigation">
		<div class="navigation__item">
			<a class="navigation__link" [routerLink]="'/portal/privacy'">{{ 'NAVIGATION.DATA_PROTECTION' | translate }}</a>
		</div>
		<div class="navigation__item">
			<a class="navigation__link" [routerLink]="'/portal/imprint'">{{ 'NAVIGATION.IMPRINT' | translate }}</a>
		</div>
		<div class="dot"></div>
	</div>
</footer>



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/footer/footer.component.html